<template>
  <ModalEdit
    :id="modalId"
    :title="$t('label.increaseLimit')"
    :loading="isLoading"
    @click="onSubmit"
  >
    <div class="p-5" style="color: #000;">
      <InputMoney v-model="$v.amount.$model" :vuelidate="$v.amount" />
    </div>
  </ModalEdit>
</template>

<script>
import { mapGetters } from 'vuex';
import { CUSTOMER_INCREASE_LIMIT } from '@/store/actions/customer';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import ModalEdit from '@/components/ui/ModalEdit';
import baseModalMixin from '@/mixins/baseModalMixin';
import InputMoney from '@/components/ui/input/InputMoney';

export default {
  mixins: [validationMixin, baseModalMixin],

  components: {
    ModalEdit,
    InputMoney,
  },

  props: {
    oldAmount: Number,
    customerId: Number,
  },

  data() {
    return {
      amount: this.oldAmount,
    };
  },

  validations() {
    return {
      amount: {
        required,
      },
    };
  },

  computed: {
    ...mapGetters(['customerIncreaseLimitStatus']),
    isLoading() {
      return this.customerIncreaseLimitStatus === 'loading';
    },
  },

  methods: {
    resetForm() {
      this.form = {
        reminderDate: '',
        description: '',
      };
      this.$v.$reset();
    },
    async onSubmit() {
      if (this.$v) {
        this.$v.amount.$touch();
        if (this.$v.amount.$anyError) {
          this.$toasted.show(this.$t('toast.failedForm'), { type: 'error' });
          return;
        }
      }

      const payload = {
        id: this.customerId,
        data: {
          limit: this.amount / 100,
        },
      };

      await this.$store.dispatch(CUSTOMER_INCREASE_LIMIT, payload);

      if (this.customerIncreaseLimitStatus === 'success') {
        this.$toasted.show(this.$t('toast.success'), { type: 'success' });
        this.hideEditModal();
        this.resetForm();
      }
    },
  },
};
</script>
